var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vocab-rate-words-slider"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"slider",class:{
			'slider-value-0': _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 0 || typeof _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 'undefined',
			'slider-value-1': _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 1,
			'slider-value-2': _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 2,
			'slider-value-3': _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 3,
			'slider-value-4': _vm.SLIDER_STOPS_REVERSE[_vm.internalValue] === 4
		},attrs:{"disabled":_vm.readonly,"min":"0","max":"3999","type":"range"},domProps:{"value":(_vm.internalValue)},on:{"__r":function($event){_vm.internalValue=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }